import { Action as ReduxAction, Dispatch } from 'redux';
import { FontType, SelectedReflowTabType } from '../../drawing/types';

namespace ReflowableContentUIAction {
  export enum ActionType {
    SET_SELECTED = 'UI_SET_REFLOWABLE_SELECTED',
    SET_FONT_TYPE = 'UI_REFLOWABLE_CONTENT_SET_FONT_TYPE',
    SET_FONT_SIZE = 'UI_REFLOWABLE_CONTENT_SET_FONT_SIZE',
    SET_LINE_HEIGHT = 'UI_REFLOWABLE_CONTENT_SET_LINE_HEIGHT',
    SET_PADDING = 'UI_REFLOWABLE_CONTENT_SET_PADDING',
    SET_SNE_ENABLE = 'UI_REFLOWABLE_SET_SNE_ENABLE',
    SET_SNE_SELECTED_PATTERN_INDEX = 'UI_REFLOWABLE_SET_SNE_SELECTED_PATTERN_INDEX',
  }

  interface SetSelectedAction extends ReduxAction {
    type: ActionType.SET_SELECTED;
    selected: SelectedReflowTabType;
  }

  interface SetFontTypeAction extends ReduxAction {
    type: typeof ActionType.SET_FONT_TYPE;
    fontType: FontType;
  }

  interface SetFontSizeAction extends ReduxAction {
    type: typeof ActionType.SET_FONT_SIZE;
    fontSize: number;
  }

  interface SetLineHeightAction extends ReduxAction {
    type: typeof ActionType.SET_LINE_HEIGHT;
    lineHeight: number;
  }

  interface SetPaddingAction extends ReduxAction {
    type: typeof ActionType.SET_PADDING;
    padding: number;
  }

  interface SetSNEEnableAction extends ReduxAction {
    type: typeof ActionType.SET_SNE_ENABLE;
    sneEnabled: boolean;
  }

  export type Action =
    SetFontTypeAction
    | SetFontSizeAction
    | SetLineHeightAction
    | SetPaddingAction
    | SetSelectedAction
    | SetSNEEnableAction;

  export function isDomesticAction(action: ReduxAction): action is Action {
    return Object.keys(ActionType).some(k => action.type === ActionType[k as any]);
  }

  export function setSelected(selected: SelectedReflowTabType, dispatch: Dispatch<ReduxAction>) {
    dispatch({ selected, type: ActionType.SET_SELECTED });
  }

  export function setFontType(fontType: FontType, dispatch: Dispatch<ReduxAction>) {
    dispatch({ fontType, type: ActionType.SET_FONT_TYPE });
  }

  export function setFontSize(fontSize: number, dispatch: Dispatch<ReduxAction>) {
    dispatch({ fontSize, type: ActionType.SET_FONT_SIZE });
  }

  export function setLineHeight(lineHeight: number, dispatch: Dispatch<ReduxAction>) {
    dispatch({ lineHeight, type: ActionType.SET_LINE_HEIGHT });
  }

  export function setPadding(padding: number, dispatch: Dispatch<ReduxAction>) {
    dispatch({ padding, type: ActionType.SET_PADDING });
  }

  export function setSNEEnableAction(sneEnabled: boolean, dispatch: Dispatch<ReduxAction>) {
    dispatch({ sneEnabled, type: ActionType.SET_SNE_ENABLE });
  }
}

export default ReflowableContentUIAction;
